module.exports = __webpack_public_path__ + "img/pr-3.b5febf8a.png";